import React, { useEffect, useState } from 'react';
import { PlaysGridRowManager } from 'services/PlaysGridRowManager';
import { observer } from 'mobx-react-lite';
import { ReactComponent as DownIcon } from 'components/icons/down.svg';
import { ISession } from 'interfaces/session/ISession';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import { SecondSourceService } from 'services/data-services/SecondSourceService';
import { ISecondSourceBoxDiscrepancy } from 'interfaces/secondSourceBox/ISecondSourcePlay';
import { BoxScoreContent, BoxScoreHeader, BoxScoreWrapper, HeaderTitle } from './styles/BoxScoreStyles';
import { GridView } from './GridView/GridView';
import DiscrepanciesBar from '../DiscrepanciesBar/DiscrepanciesBar';

interface IProps {
  rowManager: PlaysGridRowManager;
  session: ISession;
}

const SecondSourceBox: React.FC<IProps> = observer(({ rowManager, session }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const secondSourceService = useInjection<SecondSourceService>(ServiceTypes.SecondSourceService);

  const onPlayerSelect = (player: ISecondSourceBoxDiscrepancy) => {
    rowManager.secondSourceBoxManager.selectPlayer(player);
  };

  const fetchData = async () => {
    const data = await secondSourceService.fetchSecondSourceData(session.id);
    if (data) {
      rowManager.secondSourceBoxManager.updateBoxScore(data.plays);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData().finally(() => {
      setIsLoading(false);

      rowManager.cellCacheManager.rerenderAllCells();
      rowManager.updateGrid();
    });

    return () => {
      rowManager.secondSourceBoxManager.clearSelectedPlayers();
    };
  }, []);

  return (
    <BoxScoreWrapper>
      <BoxScoreHeader>
        <HeaderTitle>Secondary source comparison</HeaderTitle>{' '}
        <DownIcon className={isOpen ? 'open' : ''} onClick={() => setIsOpen((prevState) => !prevState)} />
      </BoxScoreHeader>
      {isOpen && (
        <BoxScoreContent>
          <DiscrepanciesBar onButtonClick={fetchData} discrepancyCount={rowManager.secondSourceBoxManager.discrepancies.length} />
          <GridView
            discrepancies={rowManager.secondSourceBoxManager.discrepancies}
            onPlayerSelect={onPlayerSelect}
            noDataReceived={secondSourceService.noDataReceived}
            isLoading={isLoading}
          />
        </BoxScoreContent>
      )}
    </BoxScoreWrapper>
  );
});

export default SecondSourceBox;
